import { omit } from 'lodash';
import { useRef, useEffect, ReactNode, InputHTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from 'ui/shared/controls/textField/TextField';

require('./LegacySelectField.css');

declare const $: any;


export type Props = {
    id: string;
    input: InputHTMLAttributes<HTMLSelectElement & HTMLInputElement>; // Kill: once redux-form has been eliminated from the codebase
    required?: boolean;
    allowAdditions?: boolean;
    label?: string;
    labelKey?: string;
    className?: string;
    touched?: boolean;
    error?: any;
    meta?: any;
    disabled?: boolean;
    readOnly?: boolean;
    children?: ReactNode;
    onShowAllClick?: () => void;
};

export const LegacySelectField = (props: Props) => {
    const { t } = useTranslation();

    const selectElementRef = useRef<HTMLSelectElement | null>(null);

    const { allowAdditions = false, input, onShowAllClick } = props;
    const { value } = input;
    const [ showAll, setShowAll ] = useState(false);

    useEffect(() => {
        const selectElement = selectElementRef.current;
        if (selectElement) {
            $(selectElement).dropdown({
                allowAdditions,
            });
        }
    }, [ selectElementRef, allowAdditions ]);

    useEffect(() => {
        const selectElement = selectElementRef.current;
        if (!selectElement) return;
        
        if (onShowAllClick && value === 'showAll') {
            onShowAllClick();
            setShowAll(true);
            $(selectElement).dropdown('hide');
            $(selectElement).dropdown('show');
            $(selectElement).dropdown('clear');
        }
        else if (value) {
            $(selectElement).dropdown('set selected', value);
            if (input && input.maxLength) {
                $(selectElement).parent().find(':input').attr('maxlength', input.maxLength);
            }
        }
        else {
            $(selectElement).dropdown('clear');
        }
    }, [ selectElementRef, value, onShowAllClick, setShowAll ]);

    const { id, required, label, labelKey, className, touched, error, meta, disabled, readOnly, children } = props;

    useEffect(() => {
        const selectElement = selectElementRef.current;
        if (selectElement) {
            if (!input.disabled && !disabled) {
                $(selectElement).parent().removeClass('disabled');
            }
            else {
                $(selectElement).parent().addClass('disabled');
            }
        }
    }, [ input, disabled, selectElementRef ]);

    if (readOnly) {
        return (
            <TextField
                { ...omit(props, 'input', 'children') }
                { ...input }
                disabled={ input.disabled || disabled }
            />
        );
    }
    return (
        <div
            className={ `${required ? 'required' : ''} field select-field ${className || ''}` }
        >
            { (label || labelKey) &&
                <label
                    htmlFor={ id }
                    className={ input.disabled || disabled ? 'disabled' : undefined }
                >
                    { label || t(labelKey!) }
                </label>
            }
            <select
                { ...input }
                disabled={ input.disabled || disabled }
                id={ id }
                ref={ selectElementRef }
            >
                { children }
                { onShowAllClick && !showAll &&
                    <option key="show"
                            value="showAll" >
                        { t('COMMAND.SHOW_ALL') }
                    </option> }
            </select>

            { touched && error &&
                <div className="error">
                    { meta.error }
                </div>
            }
        </div>
    );
};
